import { constants, typographyStyles } from "@newsela/angelou";

const { textS } = typographyStyles;
const { ui } = constants.colors;
const darkBlue = ui.core[700];

export const anchorCss = {
  outline: "none",

  ":focus + p": {
    outline: `1px solid ${darkBlue}`,
  },
};

export const wrapperCss = [
  {
    display: "inline-block",
    margin: 0,
  },
  textS,
];
